import React, { ReactNode, useState, useMemo } from 'react';
import { LoadingContext } from './loading-context-core';

interface LoadingProviderProps {
  children: ReactNode;
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const showLoading = () => setIsLoading(true);
  const hideLoading = () => setIsLoading(false);

  const value = useMemo(
    () => ({ showLoading, hideLoading, isLoading }),
    [isLoading] // Only recreate the value when isLoading changes
  );

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
};
